import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export const CnasAddDialog = ({ societe, last, onClose, onSaved }) => {
  const [v, setV] = useState({ numero_employeur: last?.numero_employeur || "", date_delivrance: "", date_validite: "", effectif: last?.effectif ?? "", reference: "" });
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });

  const save = async () => {
    if (!v.date_delivrance || !v.date_validite) return toast.error("Dates de délivrance et de validité obligatoires");
    setSaving(true);
    try {
      let fichier = {};
      if (file) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        fichier = { file_id: data.id, file_nom: data.filename };
      }
      await api.post("/cnas", { ...v, ...fichier, societe_id: societe.id, effectif: v.effectif === "" ? null : Number(v.effectif) });
      toast.success("Attestation CNAS ajoutée");
      onSaved();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur d'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  const field = (k, l, type = "text") => (
    <label className="text-xs text-muted-foreground space-y-1">{l}
      <Input type={type} value={v[k]} onChange={set(k)} data-testid={`cnas-input-${k}`} />
    </label>
  );

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-card" data-testid="cnas-add-dialog">
        <DialogHeader><DialogTitle>Nouvelle attestation CNAS — {societe.name}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {field("numero_employeur", "N° employeur")}
          {field("effectif", "Effectif", "number")}
          {field("date_delivrance", "Date de délivrance", "date")}
          {field("date_validite", "Date de validité", "date")}
          <div className="col-span-2">{field("reference", "N° du document")}</div>
          <label className="text-xs text-muted-foreground space-y-1 col-span-2">Attestation (PDF ou image)
            <Input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={(e) => setFile(e.target.files[0] || null)} data-testid="cnas-input-file" />
          </label>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="cnas-add-cancel">Annuler</Button>
          <Button onClick={save} disabled={saving} data-testid="cnas-add-save">Enregistrer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
